/**
 * The ProductSubscription component is used to set selling plans.
 * @param {number} index 
 * @param {HTMLElement} element 
 */
function ProductSubscription( index, element ) {
  this.$element = $( element );
  this.index = index;

  this.selectors = {
    purchaseOptions: "input[ name='purchase_option' ]",
    sellingPlans: "input[ name='selling_plan' ]"
  }

  this.initialize();
}

ProductSubscription.prototype = Object.assign( {}, ProductSubscription.prototype, {
  initialize: function() {
    this.$purchaseOptions = this.$element.find( this.selectors.purchaseOptions );
    this.$sellingPlans = this.$element.find( this.selectors.sellingPlans );

    this.$purchaseOptions.on( "change", this._handlePurchaseOptionsChange.bind( this ) );
  },

  _handlePurchaseOptionsChange: function( event ) {
    const value = event.target.value;
    // Purchase is one time if value is empty.
    const isOneTime = !Boolean( value );

    // Disable selling plan inputs if one time.
    this.$sellingPlans.prop( "disabled", isOneTime );
  }
} );

$( ".subscription" ).each( function( index, element ) {
  const subscription = new ProductSubscription( index, element );
} );



/**
 * The QuantitySelector component is used to quantify a product via single decrements and increments.
 * @param {number} index 
 * @param {HTMLElement} element 
 */
function QuantitySelector( index, element ) {
  this.$element = $( element );
  this.index = index;

  this.selectors = {
    input: ".quantity-selector__input",
    plus: ".quantity-selector__plus",
    minus: ".quantity-selector__minus",
    count: ".quantity-selector__count",
    unit: ".quantity-selector__unit"
  }

//   this.initialize();
}

QuantitySelector.prototype = Object.assign( {}, QuantitySelector.prototype, {
  initialize: function() {
    const min = this.$element.data( "min" );

    // If a min is provieded, use it.
    this.min = min != '' ? parseInt( min ) : 1;

    this.$input = this.$element.find( this.selectors.input );
    this.$plus = this.$element.find( this.selectors.plus );
    this.$minus = this.$element.find( this.selectors.minus );
    this.$count = this.$element.find( this.selectors.count );
    this.$unit = this.$element.find( this.selectors.unit );


    this.$plus.on( "click", this._handlePlus.bind( this ) );
    this.$minus.on( "click", this._handleMinus.bind( this ) );
  },

  _updateQuantifier: function( value ) {
    const singular = this.$unit.data( "single" );
    const plural = this.$unit.data( "plural" ); 
    // If there's no set singular text, use current text.
    let quantifier = singular ? singular : this.$unit.text();
    // If no plural text is provided, add an 's' by default.
    let pluralText = plural ? plural : `${ singular }s`;

    // If there's more than 1, set quantifier to plural.
    if( value > 1 ) quantifier = pluralText;

    this.$unit.text( quantifier );
  },

  _updateQuantity: function( value ) {
    // Update the input value.
    this.$input.val( value );

    // Update the visual count.
    this.$count.text( value );

    // Update the quantifier.
    this._updateQuantifier( value );
  },

  _handlePlus: function( event ) {
    const currentCount = parseInt( this.$input.val() );

    this._updateQuantity( currentCount + 1 );
  },

  _handleMinus: function( event ) {
    const currentCount = parseInt( this.$input.val() );

    // Only decrease count when it's greater than the minimum.
    if( currentCount > this.min )
      this._updateQuantity( currentCount - 1 );
  }
} );

$( ".quantity-selector" ).each( function( index, element ) {
  const quantitySelector = new QuantitySelector( index, element );
} );

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);


$(document).on('click','.quantity-selector__button',function(){
    if($(this).hasClass("quantity-selector__plus")){
      if($(this).attr('data-item') == 'false'){
        console.log('asd');
        $(this).closest('.quantity-selector__component').find('.quantity-selector__input').val(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()) + 1);
        $(this).closest('.quantity-selector__component').find('.quantity-selector__count').text(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()));
        if( $('body.template-cart').length > 0 ){
          $(this).closest('.quantity-selector__component').find('.quantity-selector__input').trigger('change');
        }
      }
      else{
        console.log('asd else');
        var combine_val = (parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()) + parseInt($(this).attr('data-cartcount')));
        var limit_cart = parseInt($('.quantity-selector').attr('data-productlimit'));
        if(combine_val <= parseInt($(this).attr('data-item'))){
        console.log('asd else if');
          var cart_item = parseInt($('.quantity-selector__button.quantity-selector__plus').attr('data-cartcount')) + parseInt($('.quantity-selector__count').text());
          if(cart_item < limit_cart){        
        console.log('asd else if if');
            $(this).closest('.quantity-selector__component').find('.quantity-selector__input').val(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()) + 1);
            $(this).closest('.quantity-selector__component').find('.quantity-selector__count').text(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()));
            var combine_val_in = (parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()) + parseInt($(this).attr('data-cartcount')));
            if(combine_val_in >= limit_cart){
              $(this).addClass('active');	
            }
            if(combine_val_in > limit_cart){
            	$(this).addClass('active');	
              $('.sample_btn .product__add-to-cart').addClass('disable');
            }
          }else{ 
            console.log('asd else if else');
            if(cart_item <= limit_cart){
              $(this).addClass('active');	
            }            
//           	$(this).removeClass('active');
//             $('.sample_btn .product__add-to-cart').removeClass('disable');
          }
        }else{           
        console.log('asd else else');
        	$(this).addClass('active');
          $('.sample_btn .product__add-to-cart').addClass('disable');
        }
      }        
    }
    if($(this).hasClass("quantity-selector__minus")){
        if($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val() > 1){
          $(this).closest('.quantity-selector__component').find('.quantity-selector__input').val(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()) - 1);
          $(this).closest('.quantity-selector__component').find('.quantity-selector__count').text(parseInt($(this).closest('.quantity-selector__component').find('.quantity-selector__input').val()));
          $('.quantity-selector__button').removeClass('active');
          $('.product__add-to-cart').removeClass('disable');
          if( $('body.template-cart').length > 0 ){
            $(this).closest('.quantity-selector__component').find('.quantity-selector__input').trigger('change');
          }
        } 
    }
});
